import React, { useState, useCallback, useEffect } from 'react';
import { Card, CardBody, CardHeader, Container, Row } from 'reactstrap';

import ActiveWhatsappBlockListForm from './components/ActiveWhatsappBlockListFormReport';
import SimpleHeader from '../../../../components/Headers/SimpleHeader';
import Pagination from '../../../../components/Pagination';
import Loader from '../../../../components/Loader';

import { useListActiveWhatsappBlockListReport } from '../hooks/useListActiveWhatsappBlockListReport';
import { ActiveWhatsappBlockListTableReport } from './components/ActiveWhatsappBlockListReport';
import {
  useMemorizeFilters,
  POSSIBLE_FILTERS_ENTITIES
} from '../../../../hooks/useMemorizeInputsFilters';

const pageKey = 'flexTableConfig::[activeWhatsappBlockReport]';

const ActiveWhatsappBlockListReport = () => {
  const [activePage, setActivePage] = useState(1);
  const [dataToSend, setDataToSend] = useState({});
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: null
  });

  const { memorizeFilters, getMemorizedFilters } = useMemorizeFilters(
    POSSIBLE_FILTERS_ENTITIES.WHATSAPP_BLOCK_LIST_REPORT
  );

  const {
    whatsappBlockNumbersReportList,
    totalWhatsappBlockNumbersReport,
    isLoadingWhatsappBlockNumbersReport,
    getWhatsappBlockNumbersReport
  } = useListActiveWhatsappBlockListReport({
    sortConfig
  });

  useEffect(() => {
    const { key, direction } = sortConfig.key
      ? sortConfig
      : JSON.parse(localStorage.getItem(pageKey)) || {
          key: null,
          direction: null
        };

    if (!key || !direction) return;

    handleSearch({
      ...getMemorizedFilters(),
      orderBy: key,
      orderType: direction
    });
  }, [sortConfig, handleSearch]);

  const handleSearch = useCallback(
    (searchFilters) => {
      const page = searchFilters?.page || 1;
      setActivePage(page);
      getWhatsappBlockNumbersReport(page, searchFilters);
    },
    [getWhatsappBlockNumbersReport]
  );

  const handlePageChange = (page) => {
    const currentFilters = getMemorizedFilters();
    memorizeFilters({ ...currentFilters, page });
    setActivePage(page);
    getWhatsappBlockNumbersReport(page, dataToSend);
  };

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/configuration"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">
                    Relatório de números bloqueados do WhatsApp
                  </h3>
                </CardHeader>
                <CardBody className="pt-2">
                  <ActiveWhatsappBlockListForm
                    handleSearch={handleSearch}
                    totalWhatsappBlockNumbersReport={
                      totalWhatsappBlockNumbersReport
                    }
                    whatsappBlockNumbersReportList={
                      whatsappBlockNumbersReportList
                    }
                    setDataToSend={setDataToSend}
                  />

                  {isLoadingWhatsappBlockNumbersReport ? (
                    <div className="col-12">
                      <Row className="justify-content-md-center">
                        <Loader />
                      </Row>
                    </div>
                  ) : (
                    <>
                      <ActiveWhatsappBlockListTableReport
                        data={whatsappBlockNumbersReportList}
                        setSortConfig={setSortConfig}
                        sortConfig={sortConfig}
                      />
                      <Pagination
                        activePage={activePage}
                        totalItemsCount={totalWhatsappBlockNumbersReport}
                        onChange={handlePageChange.bind(this)}
                      />
                    </>
                  )}
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ActiveWhatsappBlockListReport;
